/* eslint-disable no-console */
/* eslint-disable no-undef */
/* eslint-disable camelcase */
import React, { Component, Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { toast } from 'react-toastify';
import _, { isNull, isUndefined } from 'lodash';
import { withRouter } from 'react-router-dom';
import {
  SocialFeedsContainer, SideBarContainer, TileContainer, TitleContent, SideBarContent,
  StyledImage, NotificationDescription, NoComments, NoActivityFeeds, FeedsContainer,
  ScrollableFeedsContainer, AssessmentContainer, TipInformation, InputFieldContainerNew,
  PictureDivNew, MainSendNew,/* DailyTipCard,*/ CoreValueSideBarContainer, MainWrapper, FeedTopCard,
  MyProfileCard, FeedCardWrapper, RecognitionCard, PhotoCard, FriendCard, InterestCard, UserInitialsMain, DailyTip,
  Container,
  FeedIconContainer,
  FilterContainer,
  CustomMenuV1,
} from './styles';
import Waiting from '../Waiting';
import SingleFeed from './SingleFeed'; 
import { ImageUrl, imageErrorMessage } from '../../utils/constants';
import { resetOrientation, getOrientation, checkImage, applyHighlights, convertUnicode, fetchApi, getInitials } from '../../utils/methods';
import Image from '../Image';
import { withTranslation } from 'react-i18next';
import { SetDailyGoal } from '../../redux/actions';
import BirthdayWishCard from './birthdayWishCard';
import WarningPopup from './warningRecognition';
import {
  getUserProfileImage,
  addCommentReplyOnPost,
  addSocialInspiration,
  getCommentsOnPost,
  getUsersToShoutout,
  getSuggestionsList,
  getPostLikeDetails,
  getUser,
  getCompanyExemplifiesValues,
  addBuddy,
  getListOfThingsToCompleteAPI,
  getFeedHighlights,
  hideSuccussfulPopup 
} from '../../redux/actions';
const EditPostPopUp =   lazy(() => import('../EditPostPopUp'));
const DeletePostPopUp = lazy(() => import('../DeletePostPopup/deletePostConfirmation'));
import SocialFeedTextarea from './SocialFeedTextAreaNew';
import { HraIcon } from '../DailyTip/styles';
import { getListOfConnectedDevices, revokeDevice, getWorkAnniversary,getWorkAnniversaryForManagerView, getAmigoBirthday,getAmigoBirthdayForManagerView } from '../../redux/actions';
import ConnectDeviceSideBar from '../ConnectDeviceSideBar';
import PhotoAndPostFlow from '../PhotoAndPostFlow/WritePostPopup';
import PhotoAndVideoPostFlow from '../PhotoAndPostFlow/AddPhotosPopup'
import PeerRecognition from '../PeerRecognition/recognitionPopup';
const LikePopUp = lazy(() => import('../LikePopUp'));
import BirthdaySideBar from '../BirthdaySideBar';
import SuggestionForYouSocial from '../SuggestionForYou/suggationForYouSocial';
import { GetBirthdayAndAnniversaryCardStatus, GetSocialTipsAndQuotes, GetFlagPostCountDetails, Socialfeedhighlights } from '../../redux/constants/apiConstants';
import { BASE_URL } from '../../utils/config';
// import LazyImage from '../common/LazyImage/LazyImage';
import BirthdayWishPopup from './birthdayWishPopup';
import AnniversaryWishCard from './anniversaryWishCard';
import { getInspirationPost, setSocialFeedReactions } from '../../redux/actions/socialActions';
import ViewCommentModal from '../ViewCommentModal';
import RecognitionDescription from './recognitonDescription';
import DOMPurify from 'dompurify';
import { http } from '../../redux/http';
import {StyledModal, CalendarWrapper} from '../PeopleHomeV2/ManageBuddies/styles';
import {AddPost, closeIcon, DropIcon, FlagPostsIcon, ManagerRightArrowIcon, TeamCountIcon, WritePost} from '../../utils/icons';
import {StyledHeader, HeaderText, CloseIcon} from '../PhotoAndPostFlow/styles'
import TeamMemberCard from './TeamMemberCard';
import { Divider, ManagerIconContainer } from '../Manager/styles';
import SkeletonLoder from '../common/skeletonLoder';
import PrivacyPopup from './PrivacyPopup/privacypopup'
import {UpdatePostVisibility} from '../../redux/constants/apiConstants'
import GlobalAnnouncement from './GlobalAnnouncement/globalAnnouncement';
import { DropdownWrapper, CustomDropdownItemV1, CustomToggleWrapper, CustomToggle } from '../TopBarV3';
import { Dropdown } from 'react-bootstrap';

// import DriverSocialFeed from './DriverJS/DriverSocialFeed';

class SocialFeeds extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgSrc: [],
      showModal: '',
      inspirationQuote: '',
      showCommentsFor: '',
      pageNumber: 1,
      showEditDeletePopup: '',
      editDetails: '',
      editAndDelete: false,
      isUploadedImage: false,
      refreshFileReader: false,
      mentionedUsers: [],
      shoutoutType: 0,
      users: [],
      showGivenShoutout: false,
      shoutoutImage: null,
      shoutoutText: null,
      userIdArray: [],
      taggedUser: '',
      postDisabled: true,
      exemplifyID: null,
      ShowEmojiContainer: false,
      displayEmojiPicker: false,
      showConnectDevice: false,
      showPhotoPostModal: false,
      showPeerModal: false,
      showLikePostModal: false,
      feedNumber: 0,
      activeLink: 0,
      showBirthdaySideBarModal: false,
      shoutOutData: {},
      tabIndex: 0,
      showRecognitionModal: false,
      value: null,
      selectedFilter: 'All Posts',
      id: null,
      image: "",
      feedNo: null,
      editPostStatus: false,
      showAddBuddy: false,
      showBirthdayContainer: true,
      showAnniversaryContainer: true,
      addCommentWithImageStatus: false,
      feedIdForComment: '',
      commentId: '',
      showThreeComments: false,
      showViewCommentModal: false,
      specialFeed: {},
      friendStatus: '',
      handleAPICalling: true,
      fullMonth: '',
      month: '',
      showDeviceModal: false,
      user: null,
      filterType: 'Company',
      showPhotoVideoPostModal:false,
      imgSrcArray:[],
      isBirthdayCard:0,
      isAnniversaryCard:1,
      showBirthdayWishPopup:false,
      showAnniversaryWishPopup:false,
      showWarningRecognition: false,
      selectedFeedId: null,
      showCommentModalNotification: false,
      showModalRecogniton: false,
      recognitionData: [],
      showRecognitionSingle: false,
      getRecognitionData: [],
      flagPostCount: null,
      getRecentFriends: [],
      getRecentPhoto: [],
      postPopup: 0,
      privacyPopup: false,
      selectedOption: 1,
      selectedFeed:{},
      globalAnnouncementData:null,
      defaultReactions:[]
    
    }
    this.myref = React.createRef();
  }



  FILTER_OPTIONS = [
    "All Posts",
    "Recognitions",
    "Birthday",
    "Work Anniversaries",
    "Workouts",
    "Event Moments",
    "General Posts",
    "My Wishes",
    "My Posts",
    "My Community"
  ];



  handleClick1 = (event) => {
    if (!isNull(this.myref) && !isUndefined(this.myref) && !isNull(this.myref.current) && !isUndefined(this.myref.current) && !(this.myref && this.myref.current && this.myref.current.contains(event.target))) {
      this.setState({
        showConnectDevice: false,
        showBirthdaySideBarModal: false
      });
    }
  };

  handleClick = (event) => {
    if (!isNull(this.myref) && !isUndefined(this.myref) && !(this.myref && this.myref.current && this.myref.current.contains(event.target))) {
      this.setState({ ShowEmojiContainer: false });
    }
    if (!isNull(this.myref) && !isUndefined(this.myref) && !isNull(this.myref.current) && !isUndefined(this.myref.current) && !(this.myref && this.myref.current && this.myref.current.contains(event.target))) {
      this.setState({
        showConnectDevice: false,
        showBirthdaySideBarModal: false
      });
    }
  };

  componentDidMount() {
    const {selectedNotificationPostId}= this.props;
    if(selectedNotificationPostId){
      this.props.getInspirationPost(selectedNotificationPostId);
      this.props.fetchCommentsOnPost(selectedNotificationPostId);
      this.setState({
        showViewCommentModal: true,
        showCommentModalNotification:selectedNotificationPostId
      })
      
    }
    !this.props.loadingSocialPosts && window.addEventListener('scroll', this.onScroll);
    this.setState({ showCommentModalNotification: this.props.history.location.state });
    if (this.props.history.location.state) {
      this.props.getInspirationPost(this.props.history.location.state);
      this.props.fetchCommentsOnPost(this.props.history.location.state);
      this.setState({
        showViewCommentModal: true
      })
    }

    document.addEventListener("mousedown", this.handleClick1);
    const { listOfThingToComplate, fetchListOfThingsToComplete, profileImage, fetchUserProfileImage, getSuggestionsList, getCompanyExemplifiesValues, getAmigoBirthday,getAmigoBirthdayForManagerView, getWorkAnniversary,getWorkAnniversaryForManagerView, getFeedHighlights,location, userCompanyId } = this.props;
    getSuggestionsList();
    if (!profileImage) {
      fetchUserProfileImage();
    }
    if (isEmpty(listOfThingToComplate)) {
      fetchListOfThingsToComplete();
    }
    getCompanyExemplifiesValues(userCompanyId);
    // getAmigoBirthday();
    // location.pathname.includes('manager') ? getAmigoBirthdayForManagerView() : getAmigoBirthday();
    // location.pathname.includes('manager') ? getWorkAnniversaryForManagerView() : getWorkAnniversary();
    // getWorkAnniversary();
    if (location.pathname.includes('manager')) {
      getAmigoBirthdayForManagerView();
      getWorkAnniversaryForManagerView();
    } else {
      getAmigoBirthday();
      getWorkAnniversary();
    }
    this.fetchAnniversaryCardStatus(this.props.companyId);
    getFeedHighlights(this.props.user?.uid);
    this.getGlobalAnnouncementData();

    this.getFlagPostCount();
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick);
    window.removeEventListener('scroll', this.onScroll);
  }

  componentDidUpdate(prevProps) {
    if (this.state.showViewCommentModal!=true && this.props.history.location.state!=null) {
      this.props.getInspirationPost(this.props.history.location.state);
      this.props.fetchCommentsOnPost(this.props.history.location.state);
      this.setState({
        showViewCommentModal: true,
        showCommentModalNotification: this.props.history.location.state
      })
    }
    if (prevProps.devicesDisconnected !== this.props.devicesDisconnected) {
      if (this.props.devicesDisconnected.length && !this.props.dailyTip.show_tip) {
        this.setState({
          deviceNotificationModal: true
        })
      }
    }
    if (this.props.feeds !== prevProps.feeds || this.props.socialPosts !== prevProps.socialPosts) {
      this.setState({
        // storeFeeds: [...this.props.feeds],
      });
      let index = -1;
      if (!isEmpty(this.state.specialFeed) && this.props.socialPosts && Array.isArray(this.props.socialPosts) && this.props.socialPosts.length > 0) {
        index = this.props.socialPosts.findIndex((data) => data.id === this.state.specialFeed.id);
        this.setState({
          // storeFeeds: [...this.props.feeds],
          specialFeed: index !== -1 ? this.props.socialPosts[index] : {}
        });
      }
    }
    if(prevProps.isGlobalAnnouncement != this.props.isGlobalAnnouncement){
      this.getGlobalAnnouncementData();
    }

    if(prevProps.selectedNotificationPostId != this.props.selectedNotificationPostId && this.props.selectedNotificationPostId != null){
      this.props.getInspirationPost(this.props.selectedNotificationPostId);
      this.props.fetchCommentsOnPost(this.props.selectedNotificationPostId);
      this.setState({
        showViewCommentModal: true
      })

    }
  }

  fetchAnniversaryCardStatus = async(companyId)=>{
    const AuthToken = localStorage.getItem("AUTH_TOKEN");
    let url =
    BASE_URL + GetBirthdayAndAnniversaryCardStatus + companyId;
    await fetch(url, { method: "GET", headers: { AUTHTOKEN: AuthToken },credentials:'include',
      withCredentials: true }).then(
      (res) => {
        res.json().then((data) => {
          if(res.status === 200){
            this.setState({ isBirthdayCard:data.data[0].show_birthday_card,isAnniversaryCard:data.data[0].show_work_anniversary_card });

          }else{
            // toast.error(data.data.message);
          }

        }).catch(()=>{
          // toast.error(error.message);
        });
      }
    ).catch(()=>{
      // toast.error(error.message);
    });
  };


  

  openEditAndDelete = () => {
    this.setState({
      editAndDelete: !this.state.editAndDelete
    })
  };

  showHideBirthdayPopup = () => {
    this.setState({
      showBirthdayWishPopup: !this.state.showBirthdayWishPopup
    })
  };

  recognitionWarningPopup = () => {
    this.setState({
      showWarningRecognition: !this.state.showWarningRecognition
    })
  };

  showRecognitionPopup = (data) => {
    this.setState({
      showModalRecogniton: !this.state.showModalRecogniton,
      recognitionData: data
    })
  };

  onCloseRecognition = () => {
    this.setState({
      showModalRecogniton: !this.state.showModalRecogniton,
      recognitionData: []
    })
  };

  showHideAnniversaryPopup = () => {
    this.setState({
      showAnniversaryWishPopup: !this.state.showAnniversaryWishPopup
    })
  };

  toggleConnectDevices = () => {
    
    this.setState((prev) => ({
      showConnectDevice: !prev.showConnectDevice
    }));
    console.log("\n showConnectDevice :- ", this.state.showConnectDevice);

  };

  changeEditDeletePopup = (value, feed) => {
    this.setState({ editDetails: feed }, () => {
      this.setState({ showEditDeletePopup: value });
    });
  };
  editPostModel = (feed) => {
    let textDiv = document.createElement("div");
    if (feed.description) {
      // textDiv.innerHTML = convertUnicode(feed.description).split('\\n').join('</br>');

      const sanitizedDescription = DOMPurify.sanitize(convertUnicode(feed.description).split('\\n').join('</br>'));
      const fragment = document.createRange().createContextualFragment(sanitizedDescription);
      textDiv.appendChild(fragment);
    }
    let text = textDiv.textContent || textDiv.innerText || "";
    feed.description = text;
    this.setState({ editDetails: feed, editPostStatus: 1 }, () => {
      this.setState({ showPhotoPostModal: true });
    });
  };

  onHideEditDeletePopup = () => {
    this.setState({
      showEditDeletePopup: ''
    }, () => {
      this.openEditAndDelete();
    })
  };


  

  


  onChange = (e) => {
    let file = e.target.files[0];
    if (checkImage(e.target.files)) {
      if ((file?.size / 1000000) <= 20) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          this.setState({
            imgSrc: [reader.result],
            showModal: 'postModal',
            refreshFileReader: true
          });
          getOrientation(file, (or) => {
            resetOrientation([reader.result], or, (baseImage) => {
              this.setState({
                imgSrc: [baseImage],
                refreshFileReader: false
              });
            });
          });
        };
      } else {
        toast.error('Please select image file less than 20MB');
        document.getElementById('uploadPhoto') && (document.getElementById('uploadPhoto').value = '');
      }
    } else {
      toast.error(imageErrorMessage);
      document.getElementById('uploadPhoto') && (document.getElementById('uploadPhoto').value = '');
    }
  };

  getCommentsForPost = (id) => {
    const { fetchCommentsOnPost } = this.props;
    this.setState({
      showCommentsFor: id,
      showThreeComments: true
    });
    fetchCommentsOnPost(id);
  };

  getCommentsForPostModal = (id) => {
    const { fetchCommentsOnPost } = this.props;
    fetchCommentsOnPost(id);
  };


  

  // onScroll = () => {
    
  //   // !this.props.loadingSocialPosts

  //   if (this.props.loadingSocialPosts) return;
  //   const { pageNumber } = this.state;
  //   const { /*count,*/ feeds, mainFeedPagination } = this.props;
  
  //   const scrollTop = window.scrollY || document.documentElement.scrollTop; // Current scroll position
  //   const scrollHeight = document.documentElement.scrollHeight; // Total height of the document
  //   const windowHeight = window.innerHeight; // Visible portion of the screen
  
  //   const isBottom = scrollTop + windowHeight >= scrollHeight - 4500;
  
  //   let feedsData = feeds?.response ? feeds?.response : feeds;
  //   if (isBottom && feeds && feedsData?.length < mainFeedPagination?.total_posts) {
  //     this.setState(
  //       {
  //         pageNumber: pageNumber + 1,
  //       },
  //       () => {
  //         pageNumber <= mainFeedPagination.total_pages && this.props.loadMoreFeeds(this.state.pageNumber);
  //       }
  //     );
  //   }
  // };





  // Inside SocialFeeds class in SocialFeeds.js

  onScroll = () => {
    if (this.props.loadingSocialPosts) return;
    const { pageNumber, selectedFilter, filterType } = this.state; // Add selectedFilter
    const { feeds, mainFeedPagination } = this.props;

    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
  
    const isBottom = scrollTop + windowHeight >= scrollHeight - 4500;
  
    let feedsData = feeds?.response ? feeds?.response : feeds;
    if (isBottom && feeds && feedsData?.length < mainFeedPagination?.total_posts) {
      this.setState(
        { pageNumber: pageNumber + 1 },
        () => {
          // GET THE DYNAMIC PARAMS HERE
          const dynamicFilters = this.getFilterParams(selectedFilter);
          const finalFilters = {
            feed_for: filterType || "Company",
            ...dynamicFilters
          };
          
          // Pass the filters object to loadMoreFeeds
          if (pageNumber <= mainFeedPagination.total_pages) {
            this.props.loadMoreFeeds(this.state.pageNumber, finalFilters);
          }
        }
      );
    }
  };


  
  feeding = (key) => {
    this.setState({
      feedNumber: key
    });
  };

  renderViewCommentAndGetComment = (feed, id) => {
    this.setState((prev) => ({
      showViewCommentModal: !prev.showViewCommentModal,
      specialFeed: feed,
      selectedFeedId: id
    }))
    this.props.getInspirationPost(id) ;
    this.getCommentsForPostModal(id)
    this.handleScrollTrigger();
  }

  renderViewCommentModal = () => {
    this.setState((prev) => ({
      showViewCommentModal: !prev.showViewCommentModal,
      specialFeed: {}
    }))
    this.handleScrollTrigger();
  }

  closeViewCommentModal = () => {
    this.setState(() => ({
      showViewCommentModal: false,
      specialFeed: {}
    }))
    this.handleScrollTrigger();
  }

  displayDeviceModal = () => {
    this.props.fetchConnectedDevices();
    this.setState({ showDeviceModal: true })
  };

  updatePostApi = async(payload)=>{
    try{
      const res = await fetchApi(UpdatePostVisibility, "PUT",payload);
      if(res.data.message){
        toast.error(res?.data?.message);
      }else{
        toast.success(res?.data[0]);
        this.props.fetchSocialPosts(location.pathname.includes('manager') ? "Manager" :"Company");
        this.state.showViewCommentModal && this.props.getInspirationPost(this.state.selectedFeedId);
        this.setState({
          selectedOption: false,
          privacyPopup:false
        })
      }
    }catch(error){
      // toast.error(error)
    }
  }

  renderFeeds = () => {
    
    const { editAndDelete, defaultReactions } = this.state;
    const { comments, replySuccess, postReplyOnComment, profileImage, history, enableTrigger, postLikeDetails, socialCallBack, t, feeds, loadingSocialPosts,user } = this.props;
    const allPosts =  feeds && (feeds.response && feeds.response.length > 0 ? feeds.response : feeds.length > 0 && feeds);
    return (
      <div>
        
        {
          allPosts?.length > 0 ?
            <ScrollableFeedsContainer>
              {
                allPosts.map((data, index) => {
                  let feed;
                  if (data) {
                    feed = data
                  }
                  return (
                    feed ?<FeedsContainer key={`${index}-${feed.id}`} >
                      <SingleFeed
                        feed={feed}
                        specialFeed={this.state.specialFeed}
                        description={feed.description}
                        taggedUsers={feed.shoutout_user_name}
                        getCommentsForPost={this.getCommentsForPost}
                        getCommentsForPostModal={this.getCommentsForPostModal}
                        changeEditDeletePopup={this.changeEditDeletePopup}
                        editAndDelete={editAndDelete}
                        openEditAndDelete={this.openEditAndDelete}
                        profileImage={profileImage}
                        updationList="response"
                        commentCount={feed.comment_count}
                        history={history}
                        enableTrigger={enableTrigger}
                        key={`feed-${index}-${feed.id}-single-post`}
                        onChange={this.onChange}
                        handleFeed={this.feeding}
                        handleModal={this.handleLikePostModal2}
                        feedNumber={this.state.feedNumber}
                        data={postLikeDetails}
                        exemplifiesValues={this.props.exemplifiesValues}
                        showRecognition={this.showRecognition}
                        value={this.state.value}
                        id={this.state.id}
                        image={this.state.image}
                        feedNo={this.feedNo}
                        updateFeedsLike={this.props.updateFeedsLike}
                        storedFeeds={feeds}
                        editPost={this.editPostModel}
                        socialCallBack={socialCallBack}
                        handlePhotoPostModal={this.handlePhotoPostModal}
                        comments={comments}
                        postReply={postReplyOnComment}
                        replySuccess={replySuccess}
                        showViewCommentModal={this.state.showViewCommentModal}
                        renderViewCommentModal={this.renderViewCommentModal}
                        renderViewCommentAndGetComment={this.renderViewCommentAndGetComment}
                        handleScrollTrigger={this.handleScrollTrigger}
                        selectedFeedId={this.state.selectedFeedId}
                        privacyPopupHandle={this.privacyPopupHandle}
                        defaultReactions={defaultReactions}
                        getInspirationPost={this.props.getInspirationPost}
                        user={user}
                      />
                    </FeedsContainer> 
                      : null
                  )
                })
              }
              {loadingSocialPosts ? <SkeletonLoder style={{width:"568px", height:"460px", margin:"20px 0px"}}/> : null }
            </ScrollableFeedsContainer> : <NoComments>{t("No posts in this section")}</NoComments>
        }
        
      </div>
    )
  };

  addInspiration = (e) => {
    this.setState({
      inspirationQuote: e.target.value,
    });
  };

  updateText = (text, userId, taggedUserName, bool) => {
    const { userIdArray, users, taggedUser } = this.state;
    let userIdArr = [...userIdArray];
    let userNameArr = [...users];
    let taggedUsers = taggedUser;
    if (userIdArr.indexOf(userId) === -1) {
      userIdArr.push(userId);
      userNameArr.push(taggedUserName);
      if (!_.isEmpty(taggedUsers))
        taggedUsers = `${taggedUsers}, ${taggedUserName}`;
      else
        taggedUsers = taggedUserName;
    }
    this.setState({
      inspirationQuote: text,
      userIdArray: userIdArr,
      users: userNameArr,
      taggedUser: taggedUsers,
      showGivenShoutout: bool
    });
  };

  updateShoutoutArray = (mentionedUsers, text, image, exemplify_id) => {

    this.setState({
      mentionedUsers: mentionedUsers,
      showGivenShoutout: true,
      shoutoutText: text,
      shoutoutImage: image,
      shoutoutType: exemplify_id ? exemplify_id : null,
      exemplifyID: exemplify_id ? exemplify_id : null
    });
  };

  onRemoveShoutout = (array) => {
    this.setState({
      [array]: [],
      showGivenShoutout: false,
      taggedUser: '',
      shoutoutImage: null,
      shoutoutText: null,
      userIdArray: [],
      users: [],
      shoutoutType: 0,
      mentionedUsers: []
    });
  };

  onRemoveUser = () => {
    this.setState({
      taggedUser: '',
      showGivenShoutout: false,
      userIdArray: [],
      shoutoutImage: null,
      shoutoutText: null,
      users: []
    });
  };

  showEmojiPicker = () => {
    this.setState((prev) => ({
      displayEmojiPicker: !prev.displayEmojiPicker
    }))
  }

  renderInputField = (placeholder, UpdateStatus, isCommentOrReply, profileImage) => (
    <InputFieldContainerNew UpdateStatus={UpdateStatus} padding="10px" height={'100px'} onClick={() => this.handlePhotoPostModal()}>
      <PictureDivNew>
        <img src={`${ImageUrl}/${profileImage}`} />
      </PictureDivNew>
      <SocialFeedTextarea
        userCompany={this.props.userCompany}
        addInspiration={this.addInspiration}
        inspirationQuote={this.state.inspirationQuote}
        updateText={this.updateText}
        users={this.state.users}
        userIdArray={this.state.userIdArray}
        placeholder={placeholder}
        className={'CustomTextAreaField2'}
        showGivenShoutout={this.state.showGivenShoutout}
        updateShoutoutArray={this.updateShoutoutArray}
        emptyShoutoutArray={this.emptyShoutoutArray}
        onRemoveShoutout={this.onRemoveShoutout}
        isCommentOrReply={isCommentOrReply}
        shoutoutText={this.state.shoutoutText}
        shoutoutImage={this.state.shoutoutImage}
        taggedUser={this.state.taggedUser}
        onRemoveUser={this.onRemoveUser}
        enableTrigger={this.props.enableTrigger}
        ShowEmojiContainer={this.state.ShowEmojiContainer}
        myref={this.myref}
        showEmojiPicker={this.showEmojiPicker}
        displayEmojiPicker={this.state.displayEmojiPicker}
        popup={this.handlePhotoPostModal}
      />
      {this.state.inspirationQuote && this.state.inspirationQuote !== null ? (
        <MainSendNew onClick={this.addPost}>
          <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
            <circle cx="21" cy="21" r="21" fill="#0D4270" />
            <g clipPath="url(#clip0)">
              <path d="M31.7575 21.0237L15.7614 11.1406C15.5399 11.0053 15.2569 11.0298 15.0477 11.1898C14.8509 11.3621 14.777 11.6451 14.8632 11.8912L18.247 20.9375L23.4395 21.5527L18.247 22.1679L14.8632 31.216C14.777 31.4621 14.8509 31.7451 15.0477 31.9174C15.253 32.077 15.5513 32.0978 15.7614 31.9665L31.7575 22.0818C31.942 21.9588 32.0528 21.7619 32.0528 21.5527C32.0528 21.3436 31.942 21.1467 31.7575 21.0237Z" fill="url(#paint0_linear)" />
              <path d="M26.5156 20.9375H18.2469L18.4806 21.5527L18.2469 22.168H26.5156C26.8602 22.168 27.1309 21.8973 27.1309 21.5527C27.1309 21.2082 26.8602 20.9375 26.5156 20.9375ZM15.4414 20.9375H11.668C11.3279 20.9375 11.0527 21.2127 11.0527 21.5527C11.0527 21.8928 11.3279 22.168 11.668 22.168H15.4414C15.7815 22.168 16.0566 21.8928 16.0566 21.5527C16.0566 21.2127 15.7815 20.9375 15.4414 20.9375ZM14.2109 23.3984H11.668C11.3279 23.3984 11.0527 23.6736 11.0527 24.0137C11.0527 24.3537 11.3279 24.6289 11.668 24.6289H14.2109C14.551 24.6289 14.8262 24.3537 14.8262 24.0137C14.8262 23.6736 14.551 23.3984 14.2109 23.3984ZM11.668 19.707H14.2109C14.551 19.707 14.8262 19.4319 14.8262 19.0918C14.8262 18.7517 14.551 18.4766 14.2109 18.4766H11.668C11.3279 18.4766 11.0527 18.7517 11.0527 19.0918C11.0527 19.4319 11.3279 19.707 11.668 19.707Z" fill="url(#paint1_linear)" />
            </g>
            <defs>
              <linearGradient id="paint0_linear" x1="23.4402" y1="32.0527" x2="23.4402" y2="11.0528" gradientUnits="userSpaceOnUse">
                <stop stopColor="#5558FF" />
                <stop offset="1" stopColor="#00C0FF" />
              </linearGradient>
              <linearGradient id="paint1_linear" x1="19.0918" y1="24.6289" x2="19.0918" y2="18.4766" gradientUnits="userSpaceOnUse">
                <stop stopColor="#ADDCFF" />
                <stop offset="0.5028" stopColor="#EAF6FF" />
                <stop offset="1" stopColor="#EAF6FF" />
              </linearGradient>
              <clipPath id="clip0">
                <rect width="21" height="21" fill="white" transform="translate(11.0527 11.0527)" />
              </clipPath>
            </defs>
          </svg>
        </MainSendNew>) : null}
    </InputFieldContainerNew>
  );

  renderDidYouKnowTip = () => (
    <TileContainer>
      <TitleContent>
        <i className="fas fa-question" />
        <span>&nbsp;Did you know?</span>
      </TitleContent>
      <SideBarContent>
        <span>Did you know that improving your balance can improve your athletic ability?</span>
      </SideBarContent>
    </TileContainer>
  );

  acceptOrRejectRequest = (id, status) => {
    const { acceptOrRejectFriendRequest } = this.props;
    acceptOrRejectFriendRequest({ request_id: id, status: status });
  };

  showModal = () => {
    this.setState({
      showModal: 'requestsModal'
    })
  };

  renderActivityFeeds = (feeds) => (
    <TileContainer>
      <TitleContent>
        <i className="fas fa-list" />
        <span>Activity Feed:</span>
        <span><span>{feeds.length}</span>&nbsp;new notifications</span>
      </TitleContent>
      {feeds.length > 0 ? feeds.map((feed, index) => (
        <SideBarContent key={index} notificationSection >
          <StyledImage left>
            <div className="middle">
              <Image image={feed.friend_image} alt={feed.friend_name} />
            </div>
            <NotificationDescription>
              {feed.friend_name} <span className=" lowerCase">{feed.action_type + ' with '}</span>
              {feed.fof_name}
            </NotificationDescription>
          </StyledImage>
        </SideBarContent>
      )) : <NoActivityFeeds>No activities to show</NoActivityFeeds>}
    </TileContainer>
  );

  onHide = () => {
    this.setState({
      showModal: '',
      imgSrc: []
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.profileImage != nextProps.profileImage) {
      this.checkBase64(nextProps.profileImage);
    }
  }

  checkBase64(profileImage) {
    if (profileImage) {
      let arr = profileImage.split('/');
      if (arr[0] !== 'profile-Image') {
        this.setState({
          isUploadedImage: true
        })
      }
      else {
        this.setState({
          isUploadedImage: false
        })
      }
    }
  }

  togglePostButton = (value, image) => {
    const { shoutoutText, userIdArray } = this.state;
    if (userIdArray.length !== 0) {
      if (userIdArray.length !== 0 && !_.isNull(shoutoutText)) {
        return false;
      } else
        return true;
    } else if (value && value.trim() !== '' || image !== '') {
      return false;
    }
    return true;
  };

  addPost = () => {
    const { imgSrc, mentionedUsers, users, userIdArray, inspirationQuote, taggedUser, exemplifyID } = this.state;
    const { addSocialInspiration, activeTab, userCompanyId, fetchSocialPosts } = this.props;
    let inspirationData = {
      image: imgSrc.length >= 1 ? imgSrc[0] : '',
      exemplify_id: exemplifyID,
      shoutout: {
        exemplifies: mentionedUsers
      },
      description: inspirationQuote
    };
    if (!_.isEmpty(mentionedUsers)) {
      inspirationData.shoutout_user_name = `${applyHighlights(users, userIdArray, taggedUser)} - ${this.state.shoutoutText}`;
    }
    this.onHide();
    addSocialInspiration(inspirationData);
    let active = activeTab === "Company" ? "Company" : "Everybody";
    this.props.setActiveTab(active);
    this.setState({
      inspirationQuote: '',
      selectedFilter: 'All Posts',
      pageNumber: 1,
      imgSrc: [],
      showGivenShoutout: false,
      shoutoutImage: null,
      shoutoutText: null,
      taggedUser: '',
      userIdArray: [],
      users: [],
      mentionedUsers: [],
      shoutoutType: 0,
    })

    fetchSocialPosts(
      { feed_for: location.pathname.includes('manager') ? "Manager" :"Company", company_id: userCompanyId },
      1,
      10
    );
  };





  renderAssessmentPanel = () => {
    const { history } = this.props;
    return (
      <AssessmentContainer>
        <TipInformation onClick={() => history.push('/wellness-assessment/medical')}>
          <HraIcon><img src={'/public/images/HRA_icon.svg'} /></HraIcon>
          <span>TAKE THE HEALTH RISK ASSESSMENT</span>
        </TipInformation>
      </AssessmentContainer>
    );
  };

  handlePhotoPostModal = (addCommentstatus = 0, id = '', commentId = '') => {
    this.setState((prev) => ({
      showPhotoPostModal: !prev.showPhotoPostModal,
      addCommentWithImageStatus: addCommentstatus,
      feedIdForComment: id,
      commentId: commentId
    }), () => {
      this.setState({ editPostStatus: 0, editDetails: {} })




      if (this.state.showPhotoPostModal) {
        this.setState({ 
          selectedFilter: 'All Posts', 
          pageNumber: 1 
        });
        
        this.props.fetchSocialPosts(
          { feed_for: location.pathname.includes('manager') ? "Manager" :"Company", company_id: this.props.userCompanyId },
          1,
          10
        );}
    });
  };

  handlePhotoVideoPostModal = (addCommentstatus = 0, id = '', commentId = '') => {
    this.setState((prev) => ({
      showPhotoVideoPostModal: !prev.showPhotoVideoPostModal,
      addCommentWithImageStatus: addCommentstatus,
      feedIdForComment: id,
      commentId: commentId
    }), () => {
      this.setState({ editPostStatus: 0, editDetails: {} })
    });    
  };

  hidePhotoVideoPostModal = () => {
    this.setState({
      showPhotoVideoPostModal: this.state.showPhotoVideoPostModal,
      imgSrcArray:[]
    });
  };

  hidePhotoPopup = () => {
    this.setState ({
      showPhotoVideoPostModal: !this.state.showPhotoVideoPostModal,
    })
  };

  handleLikePostModal = (data) => {
    this.setState({
      feedNumber: data
    })
  };

  handleLikePostModal2 = () => {
    this.setState((prev) => ({
      showLikePostModal: !prev.showLikePostModal,
    }));
  };

  handlePeerModal = () => {
    this.setState((prev) => ({
      showPeerModal: !prev.showPeerModal,
      shoutOutData: {},
      showRecognitionSingle: false,
      selectedFilter: 'All Posts',
      pageNumber: 1
    }), () => {
      // Optional: Refresh the background feed to All Posts if the modal is opening
      if (this.state.showPeerModal) {
        this.props.fetchSocialPosts(
          { feed_for: location.pathname.includes('manager') ? "Manager" :"Company", company_id: this.props.userCompanyId },
          1,
          10
        );
      }
    });  
  };

  handleTabSwitch = (index) => {
    const { callBack } = this.props;
    this.setState({
      activeLink: index
    })
    callBack(index);
  }

  showBirthdayCardModal = () => {
    this.setState((prev) => ({
      showBirthdaySideBarModal: !prev.showBirthdaySideBarModal,
      tabIndex: 0
    }
    ));
  }

  showAnniversaryCardModal = () => {
    this.setState((prev) => ({
      showBirthdaySideBarModal: !prev.showBirthdaySideBarModal,
      tabIndex: 1
    }
    ));
  }

  showAddBuddyPopUp = (ID, status) => {
    const { addBuddy } = this.props;
    this.setState((prev) => ({
      showAddBuddy: !prev.showAddBuddy,
      friendStatus: status
    }))
    addBuddy(ID);
  }

  showAddBuddyPopUp2 = () => {
    this.setState((prev) => ({
      showAddBuddy: !prev.showAddBuddy
    }))
  }

  onChangeImage = (e) => {
    let files = e.target.files;
    let length = files.length;
  
    if (files && length > 0) {

      this.setState({ 
        selectedFilter: 'All Posts', 
        pageNumber: 1 
      });
      
      // Fetch the default feed so the background is correct
      this.props.fetchSocialPosts(
        { feed_for: location.pathname.includes('manager') ? "Manager" :"Company", company_id: this.props.userCompanyId },
        1,
        10
      );


      for (let i = 0; i < length; i++) {
        // ✅ Pass single file for validation
        if (checkImage([files[i]])) {
          if ((files[i]?.size / 1000000) <= 20) {
            let reader = new FileReader();
            reader.readAsDataURL(files[i]);
  
            reader.onloadend = () => {
              // ✅ Use functional setState to avoid overwriting
              this.setState(
                (prevState) => ({
                  imgSrcArray: [...prevState.imgSrcArray, reader.result],
                }),
                () => {
                  // ✅ Open modal only once (when first image loads)
                  if (!this.state.showPhotoVideoPostModal) {
                    this.setState({ showPhotoVideoPostModal: true });
                  }
                }
              );
            };
          } else {
            toast.error("Please select image file less than 20MB");
            document.getElementById("uploadPhoto") &&
              (document.getElementById("uploadPhoto").value = "");
          }
        } else {
          toast.error(imageErrorMessage);
          document.getElementById("uploadPhoto") &&
            (document.getElementById("uploadPhoto").value = "");
        }
      }
  
      // ✅ Reset input so same files can be selected again
      e.target.value = "";
    }
  };

  getFlagPostCount = async () => {
    try {
      const res = await fetchApi(GetFlagPostCountDetails, "GET");
      if (res.status === "success") {
        this.setState({flagPostCount:res.data.flagged_post_count})
      } else if (res.status === 'failed') {
        toast.error(res.data.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  getReceivedRecogniton = async(uId)=>{
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(`${Socialfeedhighlights}/${uId}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        this.setState({
          getRecognitionData:res.recognition_highlight,
          getRecentFriends:res.recent_friend,
          getRecentPhoto: res.recent_photo
        })
      }
    }catch(error){
      toast.error(error.message);
    }
  }

  containsDefaultPng = (str) => {
    const defaultPngFound = str?.includes("default.png");
    return defaultPngFound;
  }

  handleClickFlag = () => {
    this.props.history.push("/company/flag-posts"); // Redirect to new-page
  };

  onEnterMouse = (type) => {
    this.setState({
      postPopup: type
    })
  };


  // getFilterParams = (filter) => {
  //   switch (filter) {

  //   case "Recognitions":
  //     return { post_type_id: 3 };

  //   case "Birthday":
  //     return { post_type_id: 4 };

  //   case "Work Anniversaries":
  //     return { post_type_id: 5 };

  //   case "Workouts":
  //     return { post_type_id: 7 };

  //   case "Event Moments":
  //     return { post_type_id: 8 };

  //   case "General Posts":
  //     return { post_type_id: "1,2" };

  //   case "My Posts":
  //     return { my_posts: 1 };

  //   case "My Wishes":
  //     return { my_wishes: 1 };

  //   }
  // };



  getFilterParams = (filter) => {
    switch (filter) {
    case "My Community":
      return { visibility: "my-community" }; // Pass the specific visibility
    case "Recognitions":
      return { post_type_id: 3, visibility: "public" }; // Clear visibility for other filters
    case "Birthday":
      return { post_type_id: 4, visibility: "public" };
    case "Work Anniversaries":
      return { post_type_id: 5, visibility: "public" };
    case "Workouts":
      return { post_type_id: 7, visibility: "public" };
    case "Event Moments":
      return { post_type_id: 8, visibility: "public" };
    case "General Posts":
      return { post_type_id: "1,2", visibility: "public" };
    case "My Posts":
      return { my_posts: 1, visibility: "public" };
    case "My Wishes":
      return { my_wishes: 1, visibility: "public" };
    case "All Posts":
      return { visibility: "public" }; // Explicitly clear it
    default:
      return { visibility: "public" }; // "All Posts" should have empty visibility
    }
  };

  


  handleSelectFilter = (eventKey) => {
    const { userCompanyId } = this.props;
  
    this.setState({ selectedFilter: eventKey });
  
    const dynamicFilters = this.getFilterParams(eventKey);
  
    const finalFilters = {
      feed_for: this.state.filterType || location.pathname.includes('manager') ? "Manager" :"Company",
      company_id: userCompanyId,
      ...dynamicFilters
    };
  
    this.props.fetchSocialPosts(finalFilters, 1, 10);
  };

  

  onLeaveMouse = () => {
    this.setState({
      postPopup: 0
    })
  };

  renderView = () => {
    const { isBirthdayCard, isAnniversaryCard, /*handleAPICalling,*/ postPopup,defaultReactions,/*flagPostCount*/ selectedFilter } = this.state;
    const { feeds, history, suggestionList, profileImage, birthdayList, anniversaryList, userCompany,/* motivationalQuote,*/ dailyTip, user, getRecognitionData, getRecentFriends, getRecentPhoto,latestMember } = this.props;
    let showBirthdayContainer = true;
    let showAnniversaryContainer = true;
    if (birthdayList?.today_birthday?.length === 0 && birthdayList?.upcoming_birthday?.length === 0 && birthdayList?.recent_birthday?.length === 0) {
      showBirthdayContainer = false;
    }
    if (anniversaryList?.today_anniversary?.length === 0 && anniversaryList?.upcoming_anniversary?.length === 0 && anniversaryList?.recent_anniversary?.length === 0) {
      showAnniversaryContainer = false;
    }
    return (
      <MainWrapper >
        <div className='mainDiv'>
          <CoreValueSideBarContainer width="25.68%">
            {JSON.parse(localStorage.getItem('WELLNESS_ADMIN')) ? <Container id="team-member-container" style={{marginTop:"0px"}}>
              <div style={{display:'flex',justifyContent:'space-between',cursor:"pointer"}} onClick={this.handleClickFlag}>
                <div className="header" id="my-team" >Flagged Posts</div>
                <ManagerIconContainer isWidth={"16px"} isHeight={"16px"}  >{ManagerRightArrowIcon()}</ManagerIconContainer>
              </div>
              <Divider isMargin={'0px 0px 12px 0px'}></Divider>
              <div className='flagPostContainer'>
                <div className='flagIcon'>{FlagPostsIcon()}</div>
                <div className='totalPostContainer'>
                  <div className='totalPostText'>Total Posts  </div>
                  <div className='totalPostCount'>{this.props.flaggedPostsCount}</div>
                </div>
              </div>
            </Container>:null}
            <MyProfileCard onClick={()=>this.props.history.push({pathname: '/profile',query: {tabValue:1}})} style={{cursor:"pointer"}}>
              <div className='heading'>My Profile</div>
              <Divider isMargin={'8px 16px 12px 16px'}></Divider>
              <div className='user-details'>
                <div className='image-container'>
                  <div className='image'>
                    {!this.containsDefaultPng(profileImage)?
                      <img src={ImageUrl + "/" +profileImage}/>:
                      <UserInitialsMain color={"#184A61"} size={"24px"} border isBg>{`${getInitials(user?.fname)}${getInitials(user?.lname)}`}</UserInitialsMain>}
                  </div>
                </div>
                <div className='name'>{`${user?.fname} ${user?.lname}`}</div>
                <div className='place'>{user?.department} {user?.city? `| ${user?.city}` :null}{user?.country? `, ${user?.country}` :null}</div>
                <div className='place'>{user?.mail}</div>
              </div>
            </MyProfileCard>
            {getRecognitionData && getRecognitionData?.length>0 && this.props.companyBranding?.company_branding?.show_recognition &&  !location.pathname.includes('manager') ? ( 
              <FeedCardWrapper padding={"12px 16px 12px 16px"} >
                <div className='heading' onClick={()=>this.props.history.push({pathname: '/profile',state: { scrollTo: "recognition-received" },query: {tabValue:1, showBottom:1}})}>
                  <div className='title' >My Recognition Highlights</div>
                  <FeedIconContainer isWidth={"16px"} isHeight={"16px"}  >{ManagerRightArrowIcon()}</FeedIconContainer>
                </div>
                <Divider isMargin={'8px 16px 0px 16px'}></Divider>
                <div className='wrapper'>
                  {getRecognitionData?.length>0 && getRecognitionData?.map((data,index)=>(
                    <RecognitionCard key={index} background={data.bg_color}>
                      <div className='recognitionImage'>
                        <img src={ImageUrl +"/"+ data.icon}/>
                      </div>
                      <div className='name'>{data.title}</div>
                      <div className='count'>{data.recognition_count}</div>
                    </RecognitionCard>))}
                </div>
              </FeedCardWrapper>):null}
            {getRecentFriends && getRecentFriends[0]?.fullname ?(
              !location.pathname.includes('manager') ? (
                <FeedCardWrapper margin="20px" padding={"12px 16px 16px 16px"}>
                  <div className='heading'  onClick={()=>this.props.history.push({pathname: '/community'})} >
                    <div className='title' >My Community</div>
                    <FeedIconContainer isWidth={"16px"} isHeight={"16px"}  >{ManagerRightArrowIcon()}</FeedIconContainer>
                  </div>
                  <Divider isMargin={'8px 16px 0px 16px'}></Divider>
                  <div className='wrapper'>
                    <FriendCard>
                      <div className='image'>
                        {!this.containsDefaultPng(getRecentFriends[0]?.profile_image)?
                          <img src={ImageUrl + "/" +getRecentFriends[0]?.profile_image}/>:
                          <UserInitialsMain border isBg color={"#184A61"} size={"24px"}>{`${getInitials(getRecentFriends[0]?.fullname)}`}</UserInitialsMain>}
                      </div>
                      <div className='friend-details'>
                        <div className='name'>{getRecentFriends[0]?.fullname}</div>
                        <div className='department'>{getRecentFriends[0]?.department}</div>
                        <div className='wellnessInterest'>
                          {getRecentFriends[0]?.interests && getRecentFriends[0]?.interests?.slice(0, 5)?.map((data,index)=>
                            (<InterestCard key={index}>
                              <img src={ImageUrl +"/"+ data.interest_icon}/>
                            </InterestCard>))}
                        </div>
                      </div>
                    </FriendCard>
                  </div>
                </FeedCardWrapper>):(
                <Container id="team-member-container">
                  <div className="header" id="my-team" >My Team Members</div>
                  <Divider isMargin={'0px 0px 12px 0px'}></Divider>
                  <TeamMemberCard name={latestMember?.full_name} image={latestMember?.profile_image} bgColor={latestMember?.bg_color}  memberUid = {latestMember?.uid} />
                </Container>
              )):null}
            {getRecentPhoto?.image_url?<FeedCardWrapper margin="20px" padding={"12px 16px 16px 16px"}>
              <div className='heading' onClick={()=>this.props.history.push({pathname: '/profile',query: {tabValue:5}})}>
                <div className='title' >My Photos</div>
                <FeedIconContainer isWidth={"16px"} isHeight={"16px"}  >{ManagerRightArrowIcon()}</FeedIconContainer>
              </div>
              <Divider isMargin={'8px 16px 0px 16px'}></Divider>
              <div className='wrapper'>
                <PhotoCard>
                  <img src={ImageUrl +"/"+ getRecentPhoto.image_url}/>
                </PhotoCard>
              </div>
            </FeedCardWrapper>:null}
          </CoreValueSideBarContainer>
          <SocialFeedsContainer width="48.64%" videoCSS>
            <FeedTopCard>
              <div className='firstContainer'>
                <div className='iconsDiv'>
                  {!this.containsDefaultPng(profileImage)?
                    <img src={ImageUrl + "/" +profileImage}/>:
                    <UserInitialsMain  border isWidth={"48px"} isHeight={"48px"} color={"#184A61"}  isBg size={"16px"}>{`${getInitials(user?.fname)}${getInitials(user?.lname)}`}</UserInitialsMain>}
                </div>
                <div className='textField' onClick={() => this.handlePhotoPostModal()}>{"Start a post"}</div>
              </div>
              <div className='iconsWrapper'>
                <div className='postCard' id='write-post' onClick={() => this.handlePhotoPostModal()} onMouseEnter={() => this.onEnterMouse("post")} onMouseLeave={() => this.onLeaveMouse()}>
                  <div className='icon'>
                    {postPopup=="post"?<ManagerIconContainer isWidth="24px" isHeight="24px">{WritePost("#EA6149")}</ManagerIconContainer>:<ManagerIconContainer isWidth="24px" isHeight="24px">{WritePost()}</ManagerIconContainer>}
                  </div>
                  <div className='text'>Write a post</div>
                </div>
                {this.props.companyBranding?.company_branding?.show_recognition ? <div className='postCard' onClick={() => this.handlePeerModal()} onMouseEnter={() => this.onEnterMouse("recognition")} onMouseLeave={() => this.onLeaveMouse()}>
                  <div className='icon'>
                    {postPopup=="recognition"?<div>{TeamCountIcon(24,24,"#EA6149")}</div>:<div>{TeamCountIcon(24,24)}</div>}
                  </div>
                  <div className='text'>Give a recognition</div>
                </div>:null}
                <div className='postCard' onClick={() => this.handlePhotoVideoPostModal()} onMouseEnter={() => this.onEnterMouse("image")} onMouseLeave={() => this.onLeaveMouse()}>
                  <div className='icon'>
                    {postPopup=="image"?<div>{AddPost("#EA6149")}</div>:<div>{AddPost()}</div>}
                  </div>
                  {postPopup=="image"?<div className='text-photo'>Add photos</div>:<div className='text'>Add photos</div>}
                  <input
                    id="upload-file"
                    type="file"
                    name="user"
                    multiple={true}
                    onChange={(e) => this.onChangeImage(e)}
                    accept=".jpeg, .png, .jpg"
                    hidden
                  />
                </div>
              </div>
            </FeedTopCard>
            <FilterContainer>
              <Divider isMargin={"auto"} style={{ flex: 1 }} isColor={"#DCDCDC"}/>
              <div className="filterWrapper">
                <div className="filterText">Sort by:</div>
                <DropdownWrapper isMargin={"0"}>
                  <Dropdown onSelect={this.handleSelectFilter} style={{ cursor: "pointer"}}>
                    <Dropdown.Toggle as={CustomToggle} >
                      <CustomToggleWrapper>
                        <div style={{fontSize:"14px"}}> {selectedFilter}</div>
                        <span className="dropdown-arrow">{DropIcon("#DA6C74")}</span> 
                      </CustomToggleWrapper>
                    </Dropdown.Toggle>
                    <CustomMenuV1 align="end" isRight="-20px" isTop="16px">
                      {this.FILTER_OPTIONS.map((item) => (
                        <React.Fragment key={item}>
                          <CustomDropdownItemV1
                            isSize="16px"
                            bgColor="#DA6C74"
                            eventKey={item}
                            active={selectedFilter === item}
                          >
                            {item}
                          </CustomDropdownItemV1>
                          {item === "General Posts" && (
                            <Dropdown.Divider style={{ borderTop: "1px solid #EFEFEF", margin: "4px 8px" }} />
                          )}
                        </React.Fragment>
                      ))}
                    </CustomMenuV1>
                   
                  </Dropdown>
                </DropdownWrapper>
              </div>
            </FilterContainer>

            {this.renderFeeds(feeds)}
            
          </SocialFeedsContainer>
          <SideBarContainer width="25.68%">
            <FeedCardWrapper padding={"12px 16px 16px 16px"}>
              <div className='heading'>
                <div className='title'>Today’s Tip</div>
              </div>
              <Divider isMargin={'8px 16px 0px 16px'}></Divider>
              <div className='wrapper'>
                <DailyTip>
                  <div className='category'>
                    <div className='icon'>
                      <img src={ImageUrl +"/"+ dailyTip?.icon_image}/>
                    </div>
                    <div className='name'>{dailyTip?.category}</div>
                  </div>
                  <div className='tip'>{dailyTip?.daily_tip}</div>
                </DailyTip>
              </div>
            </FeedCardWrapper>
            {showBirthdayContainer && (!isNull(userCompany.companyStartDate) && userCompany.companyStartDate.user_birthday_notify === 1) && isBirthdayCard === 1 && 
              <BirthdayWishCard callback={this.showHideBirthdayPopup}/>}
            { showAnniversaryContainer && (!isNull(userCompany.companyStartDate) && userCompany.companyStartDate.show_work_anniversary === 1) && isAnniversaryCard === 1 &&
              <AnniversaryWishCard callback={this.showHideAnniversaryPopup}/>}              
            {/* <DailyTipCard showmotivational image={motivationalQuote&& motivationalQuote?.bg_image} margin="20px">
              <div className='heading'>
                <div className='title'>{t("Motivational Quote")}</div>
              </div>
              <div className='dailyTipImage'>
                {this.props.t(motivationalQuote.quote)}
              </div>
            </DailyTipCard> */}
            {location.pathname.includes('manager')? null : <SuggestionForYouSocial suggestionList={suggestionList} history={history} showAddBuddyPopUp={this.showAddBuddyPopUp} showAddBuddyPopUp2={this.showAddBuddyPopUp} />}
            {this.state.showViewCommentModal && this.state.specialFeed ? 
              <ViewCommentModal onClose={this.renderViewCommentModal} showModal={this.state.showViewCommentModal} feed={this.state.specialFeed}
                description={this.state.specialFeed.description}
                taggedUsers={this.state.specialFeed.shoutout_user_name}
                getCommentsForPost={this.getCommentsForPost}
                changeEditDeletePopup={this.changeEditDeletePopup}
                editAndDelete={this.state.editAndDelete}
                openEditAndDelete={this.state.openEditAndDelete}
                profileImage={this.props.profileImage}
                updationList="response"
                commentCount={this.state.specialFeed.comment_count}
                history={this.props.history}
                enableTrigger={this.props.enableTrigger}
                key={`feed-${this.state.specialFeed.id}`}
                onChange={this.onChange}
                handleFeed={this.handleFeed}
                handleModal={this.handleModal}
                feedNumber={this.state.feedNumber}
                data={this.props.postLikeDetails}
                exemplifiesValues={this.props.exemplifiesValues}
                showRecognition={this.showRecognition}
                value={this.state.value}
                id={this.state.id}
                image={this.state.image}
                feedNo={this.state.feedNo}
                updateFeedsLike={this.props.updateFeedsLike}
                storedFeeds={this.props.feeds}
                editPost={this.editPostModel}
                socialCallBack={this.props.socialCallBack}
                handlePhotoPostModal={this.handlePhotoPostModal}
                comments={this.props.comments}
                postReply={this.props.postReplyOnComment}
                replySuccess={this.props.replySuccess}
                user={user}
                defaultReactions={defaultReactions}
                privacyPopupHandle={this.privacyPopupHandle}
              /> : null}
          </SideBarContainer>
        </div>
      </MainWrapper>
    );
  };

  handleSelect = (key) => {
    this.props.setActiveTab(key);
  };

  peerCallBack = (data, index) => {
    let obj = {};
    obj = data;
    if (index === 0) {
      obj.core_value = "Happy Birthday";
      obj.image = "social/birthdayShoutOut.png";
      obj.examplifyId = 19;
      //obj.icon = "social-recognition/birthday.png",
      obj.name = data.full_name?data.full_name:data.name,
      obj.uid = data.uid
    } else {
      obj.core_value = "Work Anniversary";
      obj.image = "social/anniversaryShoutOut.png";
      obj.examplifyId = 20;
      //obj.icon = "social-recognition/anniversary.png";
      obj.name = data.full_name?data.full_name:data.name,
      obj.uid = data.uid
    } 
    this.setState((prev) => ({
      shoutOutData: { ...obj },
      showPeerModal: !prev.showPeerModal,
      showRecognitionSingle: false
      // showBirthdaySideBarModal: !prev.showBirthdaySideBarModal
    }))
  }

  peerCallBackRecognition = (data) => {
    let obj = {};
    obj = data;
    obj.core_value = data.core_value
    obj.image = data.image;
    obj.examplifyId = data.id;
    this.setState((prev) => ({
      shoutOutData: { ...obj },
      showPeerModal: !prev.showPeerModal,
      showRecognitionSingle: !prev.showRecognitionSingle
    }))
  }

  showRecognition = (feedNumber) => {
    this.setState((prev) => ({
      showRecognitionModal: !prev.showRecognitionModal,
      feedNo: feedNumber
    }));
  }

  onShoutOutSelect = (value, id, image) => {
    this.setState({
      value: value,
      id: id,
      image: image
    })
  }
  handleScrollTrigger = () => {
    this.setState((prev) => ({ handleAPICalling: !prev.handleAPICalling }));
  }

  privacyPopupHandle = (selectedFeed) => {

    window.console.log("selectedFeed",selectedFeed)
    this.setState({
      privacyPopup: !this.state.privacyPopup,
      selectedOption:selectedFeed?.visibility === "public" ? 1 : selectedFeed?.visibility === "my-community" ? 2: 1,
      selectedFeed:selectedFeed
    });
  }

  showConfirmationDelete = () =>{
    const {postDeleteStatus, t, hideSuccussfulPopup} = this.props;
    return(
      <StyledModal show={postDeleteStatus ? true : false} width={"400px"}>
        <StyledHeader background border>
          {<HeaderText color>
            <img src={ImageUrl + "/images/AdminReports/win.png"}/>
            {t('Successfully Deleted')}
          </HeaderText>}
          <CloseIcon onClick={()=>hideSuccussfulPopup()}>
            {closeIcon("#007AB1")}
          </CloseIcon>
        </StyledHeader>
        <CalendarWrapper padding="24px">
          <div className='textValue'>Your post has been successfully deleted.</div>
        </CalendarWrapper>
      </StyledModal>
    )
  }

  manageCheckBox = (value) => {
    this.setState({
      selectedOption: value
    })
  }

  getGlobalAnnouncementData = async()=>{
    const{userCompanyId,setSocialFeedReactions} = this.props;
    const res = await fetchApi(GetSocialTipsAndQuotes + "/" + userCompanyId, "GET");
    this.setState({globalAnnouncementData:res.data.announcements});
    this.setState({defaultReactions:res.data.reaction_icons});
    setSocialFeedReactions(res.data.reaction_icons)
  }

  render() {
    const { showEditDeletePopup, editDetails, showConnectDevice, showBirthdaySideBarModal, editPostStatus, showAddBuddy, addCommentWithImageStatus, feedIdForComment, commentId, /*handleAPICalling,*/ imgSrcArray, isAnniversaryCard, isBirthdayCard, showBirthdayWishPopup, showAnniversaryWishPopup, showWarningRecognition, friendStatus, showModalRecogniton, recognitionData, privacyPopup, selectedOption, selectedFeed, globalAnnouncementData } = this.state;
    const { profileImage, enableTrigger, revokeDevice, devicesDisconnected, devices, buddyDetails, socialCallBack, userCompanyId } = this.props;
    if (!profileImage) {
      return <Waiting />
    }
    return (
      <div>
        {/* <DriverSocialFeed/> */}
        <GlobalAnnouncement userCompanyId={userCompanyId} getGlobalAnnouncementData={this.getGlobalAnnouncementData} globalAnnouncementData={globalAnnouncementData}/>
        {showConnectDevice ? <ConnectDeviceSideBar innerRef={this.myref} devices={devices} revokeDevice={revokeDevice} devicesDisconnectedList={devicesDisconnected} toggleConnectDevices={this.toggleConnectDevices} showModal={showConnectDevice} /> : null}
        {showBirthdaySideBarModal ? <BirthdaySideBar index={this.state.tabIndex} peerCallBack={this.peerCallBack} showModal={showBirthdaySideBarModal} closeModal={this.showBirthdayCardModal} isAnniversaryCard={isAnniversaryCard} isBirthdayCard={isBirthdayCard}/> : null}
        {showBirthdayWishPopup&&<BirthdayWishPopup show={showBirthdayWishPopup} history={this.props.history} hidePopup={this.showHideBirthdayPopup} peerCallBack={this.peerCallBack} showBirthday="1" popupType={"birthday"}/>}
        {showAnniversaryWishPopup&&<BirthdayWishPopup show={showAnniversaryWishPopup} history={this.props.history} hidePopup={this.showHideAnniversaryPopup} peerCallBack={this.peerCallBack} popupType={"work_anniversary"}/>}
        {this.renderView()}
        {
          <PhotoAndPostFlow
            showModal={this.state.showPhotoPostModal}
            onClose={this.handlePhotoPostModal}
            history={this.props.history}
            feeds={this.props.feeds}
            acceptOrRejectFriendRequest={this.props.acceptOrRejectFriendRequest}
            setActiveTab={this.props.setActiveTab}
            loadMoreFeeds={(pageNumber) => this.props.loadMoreFeeds(pageNumber)}
            role={this.props.role}
            activeTab={this.state.filterType}
            enableTrigger={true}
            companyId={this.props.companyId}
            profileImage={this.props.profileImage}
            addPost={this.addPost}
            editDetails={editDetails}
            editPostStatus={editPostStatus}
            addCommentWithImageStatus={addCommentWithImageStatus}
            feedIdForComment={feedIdForComment}
            commentId={commentId}
            showRecognitionPopup={this.recognitionWarningPopup}
            hidePhotoVideoPopup={this.handlePhotoPostModal}
            handlePeerModal={this.handlePeerModal}
            privacyPopupHandle={this.privacyPopupHandle}
          />
        }
        {
          imgSrcArray.length>0 &&<PhotoAndVideoPostFlow
            showModal={this.state.showPhotoVideoPostModal}
            onClose={this.hidePhotoVideoPostModal}
            history={this.props.history}
            feeds={this.props.feeds}
            acceptOrRejectFriendRequest={this.props.acceptOrRejectFriendRequest}
            setActiveTab={this.props.setActiveTab}
            loadMoreFeeds={(pageNumber) => this.props.loadMoreFeeds(pageNumber)}
            role={this.props.role}
            activeTab={this.state.filterType}
            enableTrigger={true}
            companyId={this.props.companyId}
            profileImage={this.props.profileImage}
            addPost={this.addPost}
            editDetails={editDetails}
            editPostStatus={editPostStatus}
            addCommentWithImageStatus={addCommentWithImageStatus}
            feedIdForComment={feedIdForComment}
            commentId={commentId}
            imgSrcArray={imgSrcArray}
            showRecognitionPopup={this.recognitionWarningPopup}
            hidePhotoVideoPopup={this.hidePhotoVideoPostModal}
            handlePeerModal={this.handlePeerModal}
            privacyPopupHandle={this.privacyPopupHandle}
            hidePhotoPopup={this.hidePhotoPopup}
          />
        }
        {
          this.state.showPeerModal && <PeerRecognition
            onClose={this.handlePeerModal}
            showModal={this.state.showPeerModal}
            users={this.state.users}
            history={this.props.history}
            feeds={this.props.feeds}
            acceptOrRejectFriendRequest={this.props.acceptOrRejectFriendRequest}
            setActiveTab={this.props.setActiveTab}
            loadMoreFeeds={(pageNumber) => this.props.loadMoreFeeds(pageNumber)}
            role={this.props.role}
            activeTab={this.state.filterType}
            enableTrigger={true}
            companyId={this.props.companyId}
            shoutOut={this.state.shoutOutData}
            showRecognitionSingle={this.state.showRecognitionSingle}
          />
        }
        <Suspense fallback={<Waiting/>}>
          {
            this.state.showLikePostModal && <LikePopUp onClose={() => this.handleLikePostModal2()} showModal={this.state.showLikePostModal} feedNumber={this.state.feedNumber} />
          }
        </Suspense>
        <Suspense fallback={<Waiting/>}>
          {/* {showAddBuddy ? <AddBuddyPopUp showModal={showAddBuddy} onClose={this.showAddBuddyPopUp2} buddyDetails={buddyDetails} hideCancel={0} socialCallBack={socialCallBack} friendStatus={this.state.friendStatus} /> : null} */}

          {showAddBuddy&&<DeletePostPopUp
            showModal={showAddBuddy}
            onClose={this.showAddBuddyPopUp2}
            buddyDetails={buddyDetails}
            hideCancel={0}
            socialCallBack={socialCallBack}
            friendStatus={this.state.friendStatus}
            showpending= {friendStatus == "Pending"}
            showAddBuddy={isNull(friendStatus)}
            pendingStatus={friendStatus == "Pending"}
          />}
          <EditPostPopUp
            feed={editDetails}
            showModal={showEditDeletePopup == 'edit'}
            onClose={this.onHideEditDeletePopup}
            updationList="response"
            profileImage={this.props.profileImage}
            enableTrigger={enableTrigger}
          />
        </Suspense>
        <Suspense fallback={<Waiting/>}>
          <DeletePostPopUp
            feed={editDetails}
            showModal={showEditDeletePopup == 'delete'}
            onClose={this.onHideEditDeletePopup}
            updationList="response"
            title={this.props.t("DELETE POST")}
            subContent={this.props.t("This action cannot be undone.")}
            onCloseCommentPopup={this.closeViewCommentModal}
          />
        </Suspense>
        {<WarningPopup
          showModal={showWarningRecognition}
          onClose={this.recognitionWarningPopup}
          hidePhotoVideoPopup={this.handlePhotoPostModal}
          handlePeerModal={this.handlePeerModal}
        />
        }
        {showModalRecogniton&&<RecognitionDescription
          showModal={showModalRecogniton}
          onClose={this.onCloseRecognition}
          recognitionData={recognitionData}
        />}
        {privacyPopup&&<PrivacyPopup
          showModal={privacyPopup}
          onClose={this.privacyPopupHandle}
          updatePostApi={this.updatePostApi}
          singleFeed
          selectedOption={selectedOption}
          manageCheckBox={this.manageCheckBox}
          selectedFeedId={selectedFeed.id}
        />}
        {/* {this.showConfirmationDelete()} */}
      </div>
    )
  }
}

SocialFeeds.propTypes = {
  feeds: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  addSocialInspiration: PropTypes.func.isRequired,
  acceptOrRejectFriendRequest: PropTypes.func.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  activityFeeds: PropTypes.array.isRequired,
  comments: PropTypes.array,
  isLoading: PropTypes.bool.isRequired,
  fetchCommentsOnPost: PropTypes.func.isRequired,
  postReplyOnComment: PropTypes.func.isRequired,
  replySuccess: PropTypes.string,
  loadMoreFeeds: PropTypes.func.isRequired,
  iswbaTaken: PropTypes.bool.isRequired,
  profileImage: PropTypes.string,
  fetchUserProfileImage: PropTypes.func,
  count: PropTypes.number,
  role: PropTypes.string.isRequired,
  activeTab: PropTypes.string.isRequired,
  fetchUsersToShoutout: PropTypes.func,
  userCompany: PropTypes.object.isRequired,
  employeeData: PropTypes.array,
  enableTrigger: PropTypes.bool,
  userPermissions: PropTypes.array,
  companyId: PropTypes.number.isRequired,
  devices: PropTypes.array,
  revokeDevice: PropTypes.func.isRequired,
  devicesDisconnected: PropTypes.array,
  fetchConnectedDevices: PropTypes.func.isRequired,
  dailyTip: PropTypes.object,
  getSuggestionsList: PropTypes.func,
  suggestionList: PropTypes.array,
  user: PropTypes.object,
  callBack: PropTypes.func,
  getPostLikeDetails: PropTypes.func,
  postLikeDetails: PropTypes.array,
  birthdayAnniversaryWishModalStatus: PropTypes.object,
  getUser: PropTypes.func,
  userName: PropTypes.string,
  getCompanyExemplifiesValues: PropTypes.func,
  exemplifiesValues: PropTypes.array,
  updateFeedsLike: PropTypes.func,
  socialPosts: PropTypes.array,
  socialCallBack: PropTypes.func,
  buddyDetails: PropTypes.array,
  addBuddy: PropTypes.func,
  getWorkAnniversary: PropTypes.func,
  getWorkAnniversaryForManagerView : PropTypes.func,
  getAmigoBirthday: PropTypes.func,
  getAmigoBirthdayForManagerView: PropTypes.func,
  birthdayList: PropTypes.object,
  anniversaryList: PropTypes.object,
  fetchListOfThingsToComplete: PropTypes.func,
  listOfThingToComplate: PropTypes.object,
  t: PropTypes.func,
  SetDailyGoal: PropTypes.func,
  getInspirationPost: PropTypes.func,
  inspirationPost: PropTypes.array,
  location: PropTypes.object.isRequired,
  motivationalQuote: PropTypes.object,
  getFeedHighlights: PropTypes.func,
  getRecognitionData: PropTypes.array,
  getRecentFriends: PropTypes.array,
  getRecentPhoto: PropTypes.array,
  postDeleteStatus: PropTypes.bool,
  hideSuccussfulPopup: PropTypes.func,
  companyBranding:PropTypes.object,
  latestMember: PropTypes.object,
  loadingSocialPosts:PropTypes.bool,
  isMoreSocialPosts:PropTypes.bool,
  userCompanyId:PropTypes.number,
  mainFeedPagination:PropTypes.object,
  fetchSocialPosts:PropTypes.func,
  isGlobalAnnouncement:PropTypes.bool,
  flaggedPostsCount:PropTypes.number,
  selectedNotificationPostId:PropTypes.number,
  setSocialFeedReactions:PropTypes.func
};

const mapStateToProps = (state) => ({
  isLoading: state.social.isLoading,
  comments: state.social.comments,
  replySuccess: state.social.replySuccess,
  profileImage: state.profileData.profileImage,
  count: state.social.count,
  employeeData: state.peopleHome.employeeData,
  userCompany: state.profileData.userCompany,
  userPermissions: state.profileData.userPermissions,
  devices: state.wellnessDashboard.devices,
  suggestionList: state.social.suggestionList,
  devicesDisconnected: state.profileData.devicesDisconnected,
  dailyTip: state.profileData.dailyTip,
  postLikeDetails: state.social.postLikeDetails,
  userName: state.profileData.firstName,
  exemplifiesValues: state.social.exemplifiesValues,
  socialPosts: state.social.response,
  buddyDetails: state.social.buddyDetails,
  birthdayList: state.social.birthdayList,
  anniversaryList: state.profileData.workAnniversaryList,
  listOfThingToComplate: state.profileData.listOfThingToComplate,
  inspirationPost: state.social.inspirationPost,
  motivationalQuote: state.profileData.motivationalQuote,
  getRecognitionData: state.social.getRecognitionData,
  getRecentFriends: state.social.getRecentFriends,
  getRecentPhoto: state.social.getRecentPhoto,
  postDeleteStatus: state.social.postDeleteStatus,
  companyBranding: state.wellnessDashboard.companyBrandingDetails,
  loadingSocialPosts:state.social.loadingSocialPosts,
  isMoreSocialPosts:state.social.isMoreSocialPosts,
  mainFeedPagination:state.social.mainFeedPagination,
  userCompanyId: state.profileData.companyDetails.id,
  isGlobalAnnouncement: state.social.isGlobalAnnouncement,
  flaggedPostsCount: state.social.flaggedPostsCount,
  selectedNotificationPostId:state.social.selectedNotificationPostId,
});

const mapDispatchToProps = (dispatch) => ({
  fetchUsersToShoutout: (data, cb) => dispatch(getUsersToShoutout(data, cb)),
  addSocialInspiration: (inspirationData) => dispatch(addSocialInspiration(inspirationData)),
  fetchCommentsOnPost: (id) => dispatch(getCommentsOnPost(id)),
  fetchUserProfileImage: () => dispatch(getUserProfileImage()),
  postReplyOnComment: (commentId, reply, postId, shoutout, shoutOutUserName, exemplify_id, image) => dispatch(addCommentReplyOnPost(commentId, reply, postId, shoutout, shoutOutUserName, exemplify_id, image)),
  getSuggestionsList: () => dispatch(getSuggestionsList()),
  fetchConnectedDevices: () => dispatch(getListOfConnectedDevices()),
  revokeDevice: (name) => dispatch(revokeDevice(name)),
  getPostLikeDetails: (data) => dispatch(getPostLikeDetails(data)),
  getUser: () => dispatch(getUser()),
  getCompanyExemplifiesValues: (userCompanyId) => dispatch(getCompanyExemplifiesValues(userCompanyId)),
  addBuddy: (data) => dispatch(addBuddy(data)),
  getAmigoBirthday: () => dispatch(getAmigoBirthday()),
  getAmigoBirthdayForManagerView: () => dispatch(getAmigoBirthdayForManagerView()),
  getWorkAnniversary: () => dispatch(getWorkAnniversary()),
  getWorkAnniversaryForManagerView: () => dispatch(getWorkAnniversaryForManagerView()),
  fetchListOfThingsToComplete: () => dispatch(getListOfThingsToCompleteAPI()),
  SetDailyGoal: (dailyGoalData) => dispatch(SetDailyGoal(dailyGoalData)),
  // getBirthdaysList: () => dispatch(getBirthdaysList()),
  getInspirationPost: (id) => dispatch(getInspirationPost(id)),
  getFeedHighlights: (id) => dispatch(getFeedHighlights(id)),
  hideSuccussfulPopup: () => dispatch(hideSuccussfulPopup()),
  setSocialFeedReactions:(payload) => dispatch(setSocialFeedReactions(payload)),
    
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(SocialFeeds)));
